/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';
import genericReducers from '../genericReducer';
import { IReducers } from '../index';

import { GET_EVENT_KINDS } from '../../actions/employees';
import { REQUEST, FAILURE, SUCCESS } from '../../actions/utils';

import { ICommonResponse, IEventKind } from '../../api/types';

export type EventKindState = ICommonResponse<IEventKind>;

const initialState: EventKindState = {
  content: [],
  loading: false,
};
const generic = genericReducers<EventKindState>();
const eventKinds: IReducers<EventKindState> = {
  [GET_EVENT_KINDS[REQUEST]]: generic.get.request,
  [GET_EVENT_KINDS[SUCCESS]]: generic.get.success,
  [GET_EVENT_KINDS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, eventKinds);
